export default "__VITE_ASSET__CNcATbVc__"